import size from 'lodash.size';
import find from 'lodash.find';
import forEach from 'lodash.foreach';
import includes from 'lodash.includes';
import filter from 'lodash.filter';
import * as Actions from '../map/actions';
import { lSportsConfig } from '../../config/lsports.config';
import * as Helper from './lsports.helper';

const initialState = {
    originEvents: [],
    filteredEvents: [],
    eventSportGroup: {},
    locations: null,
    selectedSport: lSportsConfig.inplay.selectedSport,
    search: '',
    eventGroup: [],
    selectedLocations: [],
    isLoadingStarted: false,
    desiredLoadCount: 0,
    loadedCount: 0,
    activeMatchId: -1,
    mainMarket: lSportsConfig.inplay.mainMarket,
    mainEvents: [],
};

const lSportsInplayReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_INPLAY_LEAGUE_EVENTS: {
            let events = action.events;
            let mainEvents = state.mainEvents;

            forEach(mainEvents, (sport) => {
                if (sport.Id === events.SportId) {
                    forEach(sport.Locations, (location) => {
                        if (location.Id === events.LocationId) {
                            forEach(location.Leagues, (league) => {
                                if (league.Id === events.LeagueId) {
                                    league.Events = [...league.Events, ...events.Events];
                                }
                            });
                        }
                    });
                }
            });

            return {
                ...state,
                mainEvents: mainEvents,
            };
        }

        //InPlay
        case Actions.INPLAY_SET_EVENTS: {
            let mainEvents = action.events;

            let { selectedSport, selectedLocations, locations } = state;

            let mainFilteredEvents = Helper.ungroupEvents(mainEvents);

            if (size(mainFilteredEvents) > 0) {
                mainFilteredEvents = Helper.searchEvents(mainFilteredEvents, '');

                mainFilteredEvents = Helper.filterEvents([selectedSport], selectedLocations, mainFilteredEvents);
                locations = Helper.filterLocations(mainFilteredEvents);
                mainFilteredEvents = Helper.groupEvents(mainFilteredEvents);
            } else {
                locations = mainEvents.length > 0 && find(mainEvents, { Id: selectedSport }).Locations;
            }

            return {
                ...state,
                mainEvents: mainEvents,
                mainFilteredEvents: mainFilteredEvents,
                locations: locations,
                isLoadingStarted: true,
                loadedCount: state.loadedCount + 1,
            };
        }

        case Actions.ON_INPLAY_SPORT_SELECTED: {
            let { mainEvents } = state;

            if (size(mainEvents) === 0 || action.sportId === null) {
                return {
                    ...state,
                    selectedSport: action.sportId,
                    locations: [],
                    mainFilteredEvents: [],
                    selectedLocations: [],
                    search: '',
                };
            }

            let events = Helper.ungroupEvents(mainEvents);
            events = Helper.filterEvents([action.sportId], [], events);
            events = Helper.groupEvents(events);

            let locations = find(mainEvents, { Id: action.sportId }).Locations;

            return {
                ...state,
                selectedSport: action.sportId,
                locations: locations,
                mainFilteredEvents: events,
                selectedLocations: [],
                search: '',
            };
        }

        case Actions.ON_INPLAY_SEARCH: {
            let { selectedLocations, mainEvents } = state;

            let events = Helper.ungroupEvents(mainEvents);
            events = Helper.searchEvents(events, action.search);

            let locations = Helper.filterLocations(events);

            events = Helper.filterEvents([], selectedLocations, events);
            events = Helper.groupEvents(events);

            return {
                ...state,
                search: action.search,
                locations: locations,
                mainFilteredEvents: events,
            };
        }

        case Actions.ON_INPLAY_LOCATION_SELECTED: {
            let { selectedSport, selectedLocations, mainEvents, search } = state;

            let contains = includes(selectedLocations, action.locationId.toString());
            if (contains) {
                selectedLocations = filter(selectedLocations, (l) => {
                    return action.locationId !== l;
                });
            } else {
                selectedLocations = [...selectedLocations, action.locationId];
            }

            let events = Helper.ungroupEvents(mainEvents);
            events = Helper.searchEvents(events, search);

            let locations = Helper.filterLocations(events);
            let selectedSports = selectedSport === null ? [] : [selectedSport];
            events = Helper.filterEvents(selectedSports, selectedLocations, events);
            events = Helper.groupEvents(events);

            if (size(selectedSports) > 0) {
                locations = mainEvents.length > 0 && find(mainEvents, { Id: selectedSport }).Locations;
            }

            return {
                ...state,
                selectedLocations: selectedLocations,
                locations: locations,
                mainFilteredEvents: events,
            };
        }

        case Actions.ON_INPLAY_RESET_SELECTED_LOCATIONS: {
            let { selectedSport, mainEvents, search } = state;

            let events = Helper.ungroupEvents(mainEvents);
            events = Helper.searchEvents(events, search);

            let locations = Helper.filterLocations(events);
            let selectedSports = selectedSport === null ? [] : [selectedSport];
            events = Helper.filterEvents(selectedSports, [], events);
            events = Helper.groupEvents(events);

            if (size(selectedSports) > 0) {
                locations = mainEvents.length > 0 && find(mainEvents, { Id: selectedSport }).Locations;
            }

            return {
                ...state,
                locations: locations,
                mainFilteredEvents: events,
                selectedLocations: [],
            };
        }

        case Actions.INPLAY_SET_ACTIVE_MATCH_ID: {
            return {
                ...state,
                activeMatchId: action.matchId,
            };
        }

        case Actions.ON_INPLAY_MAIN_MARKET_SELECTED: {
            let mainMarket = state.mainMarket;

            mainMarket = forEach(mainMarket, (m) => {
                if (m.Id === action.sportId) {
                    m.selectedMarket = action.marketId;
                }
            });

            return {
                ...state,
                mainMarket: mainMarket,
            };
        }

        case Actions.ON_INPLAY_REMOVE_LEAGUE: {
            let { mainFilteredEvents } = state;

            forEach(mainFilteredEvents, (e) => {
                if (e.Id === action.sportId) {
                    forEach(e.Locations, (location) => {
                        if (location.Id === action.locationId) {
                            location.Leagues = filter(location.Leagues, (league) => {
                                return league.Id !== action.leagueId;
                            });

                            e.Locations = filter(e.Locations, (location) => {
                                return location.Leagues.length !== 0;
                            });
                        }
                    });
                    mainFilteredEvents = filter(mainFilteredEvents, (g) => {
                        return g.Locations.length !== 0;
                    });
                }
            });

            //let removeLeagueFromSportsCount = state.prematch.isSportSearchActive ? state.prematch.removeLeagueFromSportsCount : state.prematch.removeLeagueFromSportsCount + 1;

            return {
                ...state,
                mainFilteredEvents: mainFilteredEvents,
                //removeLeagueFromSportsCount: removeLeagueFromSportsCount,
            };
        }

        default:
            return state;
    }
};

export default lSportsInplayReducer;
